import { createContext } from 'react';

const WIPFeaturesContext = createContext(true);

export default WIPFeaturesContext;
